export default {
  TW: 'ไต้หวัน',
  US: 'สหรัฐอเมริกา',
  AG: 'แอนติกาและบาร์บูดา',
  AI: 'แองกวิลลา',
  AS: 'อเมริกันซามัว',
  BB: 'บาร์เบโดส',
  BM: 'เบอร์มิวดา',
  BS: 'บาฮามาส',
  CA: 'แคนาดา',
  DM: 'โดมินิกา',
  DO: 'สาธารณรัฐโดมินิกัน',
  GD: 'เกรเนดา',
  GU: 'กวม',
  JM: 'จาเมกา',
  KN: 'เซนต์คิตส์และเนวิส',
  KY: 'หมู่เกาะเคย์แมน',
  LC: 'เซนต์ลูเซีย',
  MP: 'หมู่เกาะนอร์เทิร์นมาเรียน่า',
  MS: 'มอนต์เซอรัต',
  PR: 'เปอร์โตริโก',
  SX: 'ซินต์มาร์เทน (ส่วนของเนเธอร์แลนด์)',
  TC: 'หมู่เกาะตุรกีและหมู่เกาะเคคอส',
  TT: 'ตรินิแดดและโตเบโก',
  VC: 'เซนต์วินเซนต์และเกรนาดีนส์',
  VG: 'หมู่เกาะบริติชเวอร์จิน',
  VI: 'หมู่เกาะเวอร์จินของสหรัฐอเมริกา',
  RU: 'รัสเซีย',
  KZ: 'คาซัคสถาน',
  EG: 'อียิปต์',
  ZA: 'แอฟริกาใต้',
  GR: 'กรีซ',
  NL: 'เนเธอร์แลนด์',
  BE: 'เบลเยียม',
  FR: 'ฝรั่งเศส',
  ES: 'สเปน',
  HU: 'ฮังการี',
  IT: 'อิตาลี',
  VA: 'วาติกัน',
  RO: 'โรมาเนีย',
  CH: 'สวิตเซอร์แลนด์',
  AT: 'ออสเตรีย',
  GB: 'สหราชอาณาจักร',
  GG: 'เกิร์นซีย์',
  IM: 'เกาะแมน',
  JE: 'เจอร์ซีย์',
  DK: 'เดนมาร์ก',
  SE: 'สวีเดน',
  NO: 'นอร์เวย์',
  SJ: 'สฟาลบาร์ดและยานมาเยน',
  PL: 'โปแลนด์',
  DE: 'เยอรมนี',
  PE: 'เปรู',
  MX: 'เม็กซิโก',
  CU: 'คิวบา',
  AR: 'อาร์เจนตินา',
  BR: 'บราซิล',
  CL: 'ชิลี',
  CO: 'โคลอมเบีย',
  VE: 'เวเนซุเอลา',
  MY: 'มาเลเซีย',
  AU: 'ออสเตรเลีย',
  CC: 'หมู่เกาะโคโคส (คีลิง)',
  CX: 'เกาะคริสต์มาส',
  ID: 'อินโดนีเซีย',
  PH: 'ฟิลิปปินส์',
  NZ: 'นิวซีแลนด์',
  SG: 'สิงคโปร์',
  TH: 'ประเทศไทย',
  JP: 'ญี่ปุ่น',
  KR: 'เกาหลีใต้',
  VN: 'เวียดนาม',
  CN: 'จีน',
  TR: 'ตุรกี',
  IN: 'อินเดีย',
  PK: 'ปากีสถาน',
  AF: 'อัฟกานิสถาน',
  LK: 'ศรีลังกา',
  MM: 'เมียนมาร์',
  IR: 'อิหร่าน',
  SS: 'ซูดานใต้',
  MA: 'โมร็อกโก',
  EH: 'ซาฮาราตะวันตก',
  DZ: 'แอลจีเรีย',
  TN: 'ตูนิเซีย',
  LY: 'ลิเบีย',
  GM: 'แกมเบีย',
  SN: 'เซเนกัล',
  MR: 'โมริเตเนีย',
  ML: 'มาลี',
  GN: 'กินี',
  CI: 'ไอวอรีโคสต์',
  BF: 'บูร์กินาฟาโซ',
  NE: 'ไนเจอร์',
  TG: 'โตโก',
  BJ: 'เบนิน',
  MU: 'มอริเชียส',
  LR: 'ไลบีเรีย',
  SL: 'เซียร์ราลีโอน',
  GH: 'กานา',
  NG: 'ไนจีเรีย',
  TD: 'ชาด',
  CF: 'สาธารณรัฐแอฟริกากลาง',
  CM: 'แคเมอรูน',
  CV: 'เคปเวิร์ด',
  ST: 'เซาโทเมและปรินซิเป',
  GQ: 'อิเควทอเรียลกินี',
  GA: 'กาบอน',
  CG: 'สาธารณรัฐคองโก',
  CD: 'สาธารณรัฐประชาธิปไตยคองโก',
  AO: 'แองโกลา',
  GW: 'กินี-บิสเซา',
  IO: 'อาณานิคมอินเดียมหาสมุทรอังกฤษ',
  AC: 'เกาะแอสเซนชัน',
  SC: 'เซเชลส์',
  SD: 'ซูดาน',
  RW: 'รวันดา',
  ET: 'เอธิโอเปีย',
  SO: 'โซมาเลีย',
  DJ: 'จิบูตี',
  KE: 'เคนยา',
  TZ: 'แทนซาเนีย',
  UG: 'ยูกันดา',
  BI: 'บุรุนดี',
  MZ: 'โมซัมบิก',
  ZM: 'แซมเบีย',
  MG: 'มาดากัสการ์',
  RE: 'เรอูนียง',
  YT: 'มายอต',
  ZW: 'ซิมบับเว',
  NA: 'นามิเบีย',
  MW: 'มาลาวี',
  LS: 'เลโซโท',
  BW: 'บอตสวานา',
  SZ: 'สวาซิแลนด์',
  KM: 'คอโมโรส',
  SH: 'เซนต์เฮเลนา',
  TA: 'ทริสตันดาคุนญา',
  ER: 'เอริเทรีย',
  AW: 'อารูบา',
  FO: 'หมู่เกาะแฟโร',
  GL: 'เกรนแลนด์',
  GI: 'ยิบรอลตาร์',
  PT: 'โปรตุเกส',
  LU: 'ลักเซมเบิร์ก',
  IE: 'ไอร์แลนด์',
  IS: 'ไอซ์แลนด์',
  AL: 'แอลเบเนีย',
  MT: 'มอลตา',
  CY: 'ไซปรัส',
  FI: 'ฟินแลนด์',
  AX: 'หมู่เกาะออลันด์',
  BG: 'บัลแกเรีย',
  LT: 'ลิทัวเนีย',
  LV: 'ลัตเวีย',
  EE: 'เอสโตเนีย',
  MD: 'มอลโดวา',
  AM: 'อาร์เมเนีย',
  BY: 'เบลารุส',
  AD: 'อันดอร์รา',
  MC: 'โมนาโก',
  SM: 'ซานมารีโน',
  UA: 'ยูเครน',
  RS: 'เซอร์เบีย',
  ME: 'มอนเตเนโกร',
  XK: 'โคโซโว',
  HR: 'โครเอเชีย',
  SI: 'สโลวีเนีย',
  BA: 'บอสเนียและเฮอร์เซโกวีนา',
  MK: 'มาซิโดเนียเหนือ',
  CZ: 'สาธารณรัฐเช็ก',
  SK: 'สโลวาเกีย',
  LI: 'ลิกเตนสไตน์',
  FK: 'หมู่เกาะฟอล์กแลนด์',
  BZ: 'เบลีซ',
  GT: 'กัวเตมาลา',
  SV: 'เอลซัลวาดอร์',
  HN: 'ฮอนดูรัส',
  NI: 'นิการากัว',
  CR: 'คอสตาริกา',
  PA: 'ปานามา',
  PM: 'แซงปีแยร์และมีเกอลง',
  HT: 'เฮติ',
  GP: 'กวาเดอลูป',
  BL: 'แซงต์บาร์เทเลมี',
  MF: 'แซงต์มาร์ติน',
  BO: 'โบลิเวีย',
  GY: 'กายานา',
  EC: 'เอกวาดอร์',
  GF: 'เฟรนช์เกียนา',
  PY: 'ปารากวัย',
  MQ: 'มาร์ตินีก',
  SR: 'ซูรินาเม',
  UY: 'อุรุกวัย',
  CW: 'คูราเซา',
  BQ: 'เนเธอร์แลนด์แอนทิลลิส',
  TL: 'ติมอร์ตะวันออก',
  NF: 'เกาะนอร์ฟอล์ก',
  BN: 'บรูไน',
  NR: 'นาอูรู',
  PG: 'ปาปัวนิวกินี',
  TO: 'ตองกา',
  SB: 'หมู่เกาะโซโลมอน',
  VU: 'วานูอาตู',
  FJ: 'ฟิจิ',
  PW: 'ปาเลา',
  WF: 'วอลลิสและฟูตูนา',
  CK: 'หมู่เกาะคุก',
  NU: 'นูอู',
  WS: 'ซามัว',
  KI: 'คิริบาส',
  NC: 'นิวแคลิโดเนีย',
  TV: 'ทูวาลู',
  PF: 'เฟรนช์โพลีเนเซีย',
  TK: 'โทเคลาอู',
  FM: 'รัฐไมโครนีเซีย',
  MH: 'หมู่เกาะมาร์แชล',
  KP: 'เกาหลีเหนือ',
  HK: 'ฮ่องกง',
  MO: 'มาเก๊า',
  KH: 'กัมพูชา',
  LA: 'ลาว',
  BD: 'บังกลาเทศ',
  MV: 'มัลดีฟส์',
  LB: 'เลบานอน',
  JO: 'จอร์แดน',
  SY: 'ซีเรีย',
  IQ: 'อิรัก',
  KW: 'คูเวต',
  SA: 'ซาอุดีอาระเบีย',
  YE: 'เยเมน',
  OM: 'โอมาน',
  PS: 'ปาเลสไตน์',
  AE: 'สหรัฐอาหรับเอมิเรตส์',
  IL: 'อิสราเอล',
  BH: 'บาห์เรน',
  QA: 'กาตาร์',
  BT: 'ภูฏาน',
  MN: 'มองโกเลีย',
  NP: 'เนปาล',
  TJ: 'ทาจิกิสถาน',
  TM: 'เติร์กเมนิสถาน',
  AZ: 'อาเซอร์ไบจาน',
  GE: 'จอร์เจีย',
  KG: 'คีร์กีซสถาน',
  UZ: 'อุซเบกิส',
} as Record<string, string>;
